import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { getTranslation } from "../../utils/utils";

export interface DialogConfig {
  title?: string;
  description?: string | string[];
  saveBtnLabel?: string;
  cancelBtnLabel?: string;
  discardBtnLabel?: string;
  showErrorIcon?: boolean;
  hideCloseIcon?: boolean;
  size?: string;
  hideSaveBtn?: boolean;
  hideCloseBtn?: boolean;
  hideDiscardBtn?: boolean;
  showZoomBtn?: boolean;

  onCloseRequest?: (e: any) => Promise<boolean>;
}
@Component({
  selector: "kt-common-delete-dialog",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class CommonDeleteComponent implements OnInit {
  translation;
  title = "";
  saveBtnLabel = "";
  cancelBtnLabel = "";
  discardBtnLabel = "";
  description = "";
  size = "small";
  showZoomBtn = false;
  isMultiLine = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: DialogConfig,
    public dialogRef: MatDialogRef<CommonDeleteComponent>
  ) {}

  ngOnInit(): void {
    this.translation = getTranslation();
    this.title =
      this.data.title || this.translation["DELETE_RECORD"] || ".DELETE_RECORD";
    this.saveBtnLabel =
      this.data.saveBtnLabel || this.translation.DELETE || ".DELETE";
    this.cancelBtnLabel =
      this.data.cancelBtnLabel || this.translation.CANCEL || ".CANCEL";
    this.discardBtnLabel = this.data.discardBtnLabel;
    this.description =
      this.data.description ||
      this.translation.IF_YOU_DELETE_THIS_RECORD_WARNING ||
      ".If you delete this record, you won't be able to recover it. Do you want to delete it?";
    this.size = this.data.size || "small";
    this.showZoomBtn = this.data.showZoomBtn || false;
    this.isMultiLine = Array.isArray(this.description);
  }
}
